import Component from '$store/components/search/Controls.tsx'
import type { Props } from '$store/components/search/Controls.tsx'

function Island(props: Props) {
	return <Component {...props} />
}

export default Island
